import { paraHeaderGeo } from '@/shared/utils/geoPosicao';
import { posicaoDaJanelaCorrente } from '@/shared/utils/posicaoEmCache';

export async function headersDeGeoDoPortal(): Promise<Record<string, string>> {
  const geo = paraHeaderGeo(await posicaoDaJanelaCorrente());
  return geo ? { 'X-Client-Geo': geo } : {};
}
